// extracted by mini-css-extract-plugin
module.exports = {"linkBlockColumns":"DesktopLinkSection_linkBlockColumns__2c3eI"};